import { CopyableText } from '~/components/common/copyable-text';

/**
 * A long id shown shortened (start…end) in monospace with a copy button that
 * copies the full value; the full id is on hover. Typography lives here so
 * table columns never need font classes.
 */
export function ShortId({
  id,
  label = 'id',
  head = 8,
  tail = 6,
  testId = 'short-id',
}: {
  id: string;
  /** What the id is, for the copy button's name and toast ("Product id"). */
  label?: string;
  head?: number;
  tail?: number;
  /** E2E `data-testid` root; the copyable text is `${testId}-text`. */
  testId?: string;
}) {
  if (!id)
    return (
      <span data-testid={`${testId}-empty`} className="text-muted-foreground">
        —
      </span>
    );
  const short = id.length > head + tail + 1 ? `${id.slice(0, head)}…${id.slice(-tail)}` : id;
  return (
    <span data-testid={testId} title={id} className="inline-flex min-w-0">
      <CopyableText
        testId={`${testId}-text`}
        text={id}
        className="text-foreground font-mono text-xs"
        ariaLabel={`Copy ${label}`}
        copyMessage={`${label.charAt(0).toUpperCase()}${label.slice(1)} copied`}
      >
        {short}
      </CopyableText>
    </span>
  );
}
